export default __webpack_public_path__ + "static/media/watering-can-converted.8d8889a1.png";